module.exports = __webpack_public_path__ + "img/xk.1c73126d.jpg";